import $ from 'jquery';
import {hideElem, showElem, type DOMEvent} from '../utils/dom.ts';

export function initRepoRelease() {
  document.addEventListener('click', (e: DOMEvent<MouseEvent>) => {
    if (e.target.matches('.remove-rel-attach')) {
      const uuid = e.target.getAttribute('data-uuid');
      const id = e.target.getAttribute('data-id');
      document.querySelector<HTMLInputElement>(`input[name='attachment-del-${uuid}']`).value = 'true';
      hideElem(`#attachment-${id}`);
    }
  });
}

export function initRepoReleaseNew() {
  if (!document.querySelector('.repository.new.release')) return;

  initTagNameEditor();
}

function initTagNameEditor() {
  const el = document.querySelector('#tag-name-editor');
  if (!el) return;

  const allspiceTagWarning = document.querySelector('#allspice-tag-warning');
  const allspiceTagWarningDetailLinks = Array.from(document.querySelectorAll<HTMLAnchorElement>('.allspice-tag-warning-detail'));
  const existingTags = JSON.parse(el.getAttribute('data-existing-tags'));
  const defaultTagHelperText = el.getAttribute('data-tag-helper');
  const newTagHelperText = el.getAttribute('data-tag-helper-new');
  const existingTagHelperText = el.getAttribute('data-tag-helper-existing');
  const allspiceTagURLStub = allspiceTagWarning.getAttribute('data-commit-url-stub');

  // show the confirmation modal if release is using an existing tag
  let requiresConfirmation = false;
  $('.allspice-confirm').on('click', (event) => {
    const confirmButton = event.target as HTMLButtonElement;
    if (requiresConfirmation) {
      event.preventDefault();

      if (confirmButton.classList.contains('allspice-draft')) {
        $('#allspice-tag-confirm-draft-modal').modal({
          onApprove() {
            // need to add hidden input with draft form value
            // (triggering form submission doesn't include the button data)
            const draftInputElement = document.createElement('input');
            draftInputElement.type = 'hidden';
            draftInputElement.name = 'draft';
            draftInputElement.value = '1';
            confirmButton.form.append(draftInputElement);
            $(confirmButton.form).trigger('submit');
          },
        }).modal('show');
      } else {
        $('#allspice-tag-confirm-modal').modal({
          onApprove() {
            $(confirmButton.form).trigger('submit');
          },
        }).modal('show');
      }
    }
  });

  const tagNameInput = document.querySelector<HTMLInputElement>('#tag-name');
  const hideTargetInput = function(tagNameInput: HTMLInputElement) {
    const value = tagNameInput.value;
    const tagHelper = document.querySelector('#tag-helper');
    if (value in existingTags) {
      // If the tag already exists, hide the target branch selector.
      hideElem('#tag-target-selector');
      tagHelper.textContent = existingTagHelperText;
      showElem('#allspice-tag-warning');
      for (const detail of allspiceTagWarningDetailLinks) {
        detail.href = `${allspiceTagURLStub}/${existingTags[value]}`;
        detail.textContent = existingTags[value].substring(0, 10);
      }
      requiresConfirmation = true;
    } else {
      showElem('#tag-target-selector');
      tagHelper.textContent = value ? newTagHelperText : defaultTagHelperText;
      hideElem('#allspice-tag-warning');
      requiresConfirmation = false;
    }
  };
  hideTargetInput(tagNameInput); // update on page load because the input may have a value
  tagNameInput.addEventListener('input', (e) => {
    hideTargetInput(e.target as HTMLInputElement);
  });
}
